import {
  Component,
  OnInit,
  ViewChildren,
  ViewEncapsulation,
} from "@angular/core";
import { TransactionsService } from "src/app/api/transactions.service";
import {
  MenuController,
  ModalController,
  IonInput,
  ToastController,
  LoadingController,
} from "@ionic/angular";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  ValidationErrors,
} from "@angular/forms";
import { NewPreviewPage } from "../new-preview/new-preview.page";
import { ActivatedRoute } from "@angular/router";
import { AppSettings } from "src/app/app-settings";

@Component({
  selector: "app-pending",
  templateUrl: "./pending.page.html",
  styleUrls: ["./pending.page.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class PendingPage implements OnInit {
  public pendingForm: FormGroup;

  //Retrieves the list of all part inputs. Usefull to set focus when adding a new one.
  @ViewChildren("partInput") refs: IonInput[];

  public pendingItems: any[] = [];
  public conditions: string[] = ["REF", "NOB", "NEW", "AS IS", "USED"];
  public manufacturerOptions: string[] = ["CISCO", "JUNIPER", "HPE", "DELL", "ARISTA", "IBM", "MELLANOX", "NVIDIA", "BROCADE", "OTHER"];
  public manufacturerList: string[] = ["CISCO", "JUNIPER", "HPE"];
  public manufacturerPriceConstraints: any[] = [];
  public manufacturerInput: string = null;
  public transactionType: string;
  public transactionMailing: string;

  isWeb = AppSettings.IS_WEB;

  constructor(
    private route: ActivatedRoute,
    private modalCtrl: ModalController,
    private toastCtrl: ToastController,
    private loadingCtrl: LoadingController,
    private menuCtrl: MenuController,
    private transactionService: TransactionsService,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.transactionType = this.route.snapshot.paramMap.get("type");
    this.transactionMailing = this.route.snapshot.paramMap.get("mailing");
    this.pendingForm = this.formBuilder.group({});

    this.addControlsNewTableLine();
    this.transactionService
      .getConstraints(this.transactionMailing, this.transactionType)
      .then((r) => {
        if (r["results"])
          this.manufacturerPriceConstraints = r["results"].map(
            (o) => o.manufacturer
          );
      })
      .catch(async (e) => {
        let errorMessage = "";
        for (var err in e.error)
          errorMessage += err + " : " + e.error[err].join(".\n");

        let errorToast = await this.toastCtrl.create({
          message: errorMessage,
          showCloseButton: true,
          duration: 3500,
          position: "bottom",
          color: "light",
        });
        errorToast.present();
      });
    this.pendingItems = [
      {
        transaction_reference_typed: undefined,
        manufacturer: undefined,
        other_manufacturer: undefined,
        quantity: undefined,
        price: undefined,
        condition: "REF",
        comment: undefined,
        transaction_type: this.transactionType,
      },
    ];
  }

  addOffer() {
    this.addControlsNewTableLine();

    this.pendingItems.push({
      transaction_reference_typed: undefined,
      manufacturer: undefined,
      other_manufacturer: undefined,
      quantity: undefined,
      price: undefined,
      condition: "REF",
      comment: undefined,
      transaction_type: this.transactionType,
    });

    //Set the focus on the newly created row, on its "Part Number" field
    //The timeout is required to let the time to the element to be added to the DOM.
    setTimeout(() => {
      this.refs["_results"][this.pendingItems.length - 1].setFocus();
    }, 100);
  }

  //Patch values of the form group as it is not done automatically
  //At the end, pop the last control and item of the pending items.
  //Reminder : The pending items values are "useless", they are only set when sending items
  deleteOffer(index) {
    for (let i = index; i < this.pendingItems.length - 1; i++) {
      let partNumberName = "part_number-" + i;
      let manufacturerName = "manufacturer-" + i;
      let quantityName = "quantity-" + i;
      let priceName = "price-" + i;
      let commentName = "comment-" + i;

      //Using a tmp object to be able to dynamically set the anme of the attributes
      let tmp = {};
      tmp[partNumberName] = this.pendingForm.get(
        "part_number-" + (i + 1)
      ).value;
      tmp[manufacturerName] = this.pendingForm.get(
        "manufacturer-" + (i + 1)
      ).value;
      tmp[quantityName] = this.pendingForm.get("quantity-" + (i + 1)).value;
      tmp[priceName] = this.pendingForm.get("price-" + (i + 1)).value;
      tmp[commentName] = this.pendingForm.get("comment-" + (i + 1)).value;

      this.pendingForm.patchValue(tmp);
    }
    this.pendingItems.pop();
    this.removeControlsTableLine();

    if (this.pendingItems.length === 0) {
      this.addOffer();
    }
  }

  clear() {
    for (let i = this.pendingItems.length - 1; i >= 0; i--) {
      this.pendingItems.pop();
      this.removeControlsTableLine();
    }

    this.addOffer();
  }

  async sendAll() {
    let t = this;
    if (!this.pendingForm.valid) {
      let errorMessage = this.getFormValidationErrors();

      let toast = await this.toastCtrl.create({
        message: errorMessage,
        duration: 2000,
        color: "light",
        showCloseButton: true,
        position: "bottom",
      });
      toast.present();
      this.markFormGroupTouched(this.pendingForm);
    } else {
      Object.keys(this.pendingForm.value).forEach((input) => {
        let attributeValue = this.pendingForm.get(input).value;
        let attributeName = input.split("-")[0];
        let elementIndex = input.split("-")[1];

        //We only append the element if it contains a value
        //We also replace "part_number" by "transaction_reference_typed"
        if (
          attributeValue !== "" &&
          attributeValue !== null &&
          attributeValue !== undefined
        ) {
          this.pendingItems[elementIndex][
            attributeName !== "part_number"
              ? attributeName
              : "transaction_reference_typed"
          ] = attributeValue;
        }
        this.pendingItems[elementIndex]["transaction_mailing"] =
          this.transactionMailing;

        if (
          attributeName == "manufacturer" &&
          attributeValue == "OTHER" &&
          (t.transactionType == "WTS" ||
            t.transactionType == "WTB" ||
            t.transactionType == "RFQ"
          )
        ) {
          this.pendingItems[elementIndex]["manufacturer"] =
            this.pendingForm.get("other_manufacturer-" + elementIndex).value;
        }
      });

      let loader = await this.loadingCtrl.create({
        message: "Creating the " + this.transactionType,
      });

      loader.present();


      const pendingItemsWithComment = this.pendingItems.map((item, index) => {
        let price = this.pendingForm.get(`price-${index}`).value;
        // Set price to 0 if it's empty, null, undefined, or 0
        if (price === null || price === undefined || price === "" || price === 0) {
          price = 0;
        }
        return {
          ...item,
          comment: this.pendingForm.get(`comment-${index}`).value,
          price: price,
        };
      });

      this.transactionService
        .create(pendingItemsWithComment)
        .then(async (response) => {
          let modal = await this.modalCtrl.create({
            component: NewPreviewPage,
            componentProps: {
              emailInfos: response,
            },
            backdropDismiss:false,
            cssClass: !this.isWeb ? "modal-fullscreen" : "",
          });

          modal.onDidDismiss().then((response) => {
            if (response.data) {
              this.clear();
            }
          });

          modal.present();
        })
        .catch(async (e) => {
          let errorMessage = "";
          for (var err in e.error)
            errorMessage += err + " : " + e.error[err].join(".\n");

          let errorToast = await this.toastCtrl.create({
            message: errorMessage,
            showCloseButton: true,
            duration: 3500,
            position: "bottom",
            color: "light",
          });
          errorToast.present();
        })
        .finally(() => {
          loader.dismiss();
        });
    }
  }

  changeConditionItem(index, value) {
    this.pendingItems[index].condition = value;
  }

  addControlsNewTableLine() {
    const t = this;
    this.pendingForm.addControl(
      "part_number-" + this.pendingItems.length,
      new FormControl("", Validators.required)
    );

    let manufacturerValidations = Validators.maxLength(60)
    manufacturerValidations = Validators.compose([
      Validators.required,
      manufacturerValidations,
    ]);
    this.pendingForm.addControl(
      "manufacturer-" + this.pendingItems.length,
      new FormControl("", manufacturerValidations)
    );
    this.pendingForm.addControl(
      "other_manufacturer-" + this.pendingItems.length,
      new FormControl("", Validators.maxLength(60))
    );

    this.pendingForm.addControl(
      "quantity-" + this.pendingItems.length,
      new FormControl(
        "",
        Validators.compose([
          Validators.required,
          Validators.min(1),
          Validators.max(99999),
        ])
      )
    );
    this.pendingForm.addControl(
      "price-" + this.pendingItems.length,
      new FormControl(
        "",
        Validators.compose([Validators.min(0), this.customPriceCheck])
      )
    );

    this.pendingForm.addControl(
      "comment-" + this.pendingItems.length,
      new FormControl("", null)
    );


    let priceControl = t.pendingForm.get("price-" + this.pendingItems.length);
    let other_manufacturerControl = t.pendingForm.get(
      "other_manufacturer-" + this.pendingItems.length
    );
    if (this.transactionType == "WTS") {
      this.pendingForm
        .get("manufacturer-" + this.pendingItems.length)
        .valueChanges.subscribe((val) => {
          val = val || "";
          if (t.manufacturerPriceConstraints.includes(val.toUpperCase())) {
            if (this.manufacturerList.includes(val)) {
              priceControl.setValidators(
                Validators.compose([
                  Validators.required,
                  Validators.min(0),
                  t.customPriceCheck,
                ])
              );
            }
          } else {
            priceControl.setValidators(
              Validators.compose([Validators.min(0), t.customPriceCheck])
            );
            let other_manufacturerValidations = Validators.maxLength(60);

            if (val == "OTHER") {
              other_manufacturerValidations = Validators.compose([
                Validators.required,
                other_manufacturerValidations,
              ]);
            }
            other_manufacturerControl.setValidators(
              other_manufacturerValidations
            );
          }
          priceControl.updateValueAndValidity();
        });
      other_manufacturerControl.valueChanges.subscribe((val) => {
        val = val || "";
        if (this.manufacturerList.includes(val)) {
          priceControl.setValidators(
            Validators.compose([
              Validators.required,
              Validators.min(0),
              t.customPriceCheck,
            ])
          );
        }
        if (t.manufacturerPriceConstraints.includes(val.toUpperCase())) {
          priceControl.setValidators(
            Validators.compose([
              Validators.required,
              Validators.min(0),
              t.customPriceCheck,
            ])
          );
        } else {
          priceControl.setValidators(
            Validators.compose([Validators.min(0), t.customPriceCheck])
          );
        }
        priceControl.updateValueAndValidity();
      });
    }
  }

  removeControlsTableLine() {
    //Remove the last line of controls as it is not used anymore
    this.pendingForm.removeControl("part_number-" + this.pendingItems.length);
    this.pendingForm.removeControl("manufacturer-" + this.pendingItems.length);
    this.pendingForm.removeControl(
      "other_manufacturer-" + this.pendingItems.length
    );
    this.pendingForm.removeControl("quantity-" + this.pendingItems.length);
    this.pendingForm.removeControl("price-" + this.pendingItems.length);
    this.pendingForm.removeControl("comment-" + this.pendingItems.length);
  }

  public customPriceCheck(form: FormControl): { [key: string]: any } {
    let errors = {};
    if (form.value !== null && (form.value + "").length > 11) {
      errors["priceLength"] = (form.value + "").length;
    }

    if (
      form.value !== null &&
      !!form.value.toString().split(/[,.]/)[1] &&
      (form.value.toString().split(/[,.]/)[1] + "").length > 2
    ) {
      errors["decLength"] = form.value.toString().split(/[,.]/)[1].length;
    }

    if (errors !== {}) {
      return errors;
    }

    return null;
  }

  //Recursively mark all controls of a form as touched.
  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach((control) => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  //Retrieves error messages to get a cleaner display.
  //Only shows 6 of them. Change maxNumberOfErrors to get more/less.
  private getFormValidationErrors() {
    let errorMessage = "";
    let maxNumberOfErrors = 6;

    Object.keys(this.pendingForm.controls).some((key) => {
      const controlErrors: ValidationErrors = this.pendingForm.get(key).errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).some((keyError) => {
          let lineIndex = parseInt(key.split("-")[1]) + 1;
          let attribute = key.split("-")[0].replace("_", " ");
          errorMessage +=
            "Line " + lineIndex + ", on " + attribute + " : " + keyError + "\n";
          maxNumberOfErrors--;
          if (maxNumberOfErrors === 0) return true;
          //We focus the part number field of the first line having an error
          if (maxNumberOfErrors === 5) {
            this.refs["_results"][lineIndex - 1].setFocus();
          }
        });
        if (maxNumberOfErrors === 0) return true;
      }
    });
    return errorMessage;
  }
}